import {
  CheckIfGroupIsFinishedRule,
  CheckIfTheTicketGroupCanBeSoldRule,
  CheckSalesOpeningRule,
  ConcatStatusSessionInDateTicketRule,
  IdentifyTicketWithCarouselIdRule,
  SortTicketsByDateAndClosingAndStockRule,
  SortTicketsByOrderRule
} from '../implementations';
import { RuleSetStrategy } from '../strategies/RuleSetStrategy';
import { Rule } from '../types/Rule';

export class BotafogoFutebolRuleSetStrategy implements RuleSetStrategy {
  getRules(): Rule[] {
    return [
      new CheckSalesOpeningRule(),
      new CheckIfGroupIsFinishedRule(),
      new IdentifyTicketWithCarouselIdRule(),
      new SortTicketsByDateAndClosingAndStockRule(),
      new CheckIfTheTicketGroupCanBeSoldRule(),
      new ConcatStatusSessionInDateTicketRule(),
      new SortTicketsByOrderRule(),
    ];
  }
}
